// @flow strict

import React from "react";

import type { UnregisteredStore, Store } from "~robin-hood/redux/store";
import { AGENT_GATO } from "~robin-hood/redux/store";
import { RegistroEquipoForm } from "~robin-hood/unregistered/RegistroEquipoForm";
import classnames from "~common/classnames";
import styles from "./RegistroEquipo.module.css";
// import typewriter from "~robin-hood/animations/typewriter.module.css";
import { Typewriter } from "~src/apps/components/Typewriter";
import type { RouterHistory } from "react-router-dom";

type Props = {
  history: RouterHistory,
  store: UnregisteredStore,
  updateStore: (Store) => void,
};

export function RegistroEquipo(props: Props): React$Node {
  const [showForm, setShowForm] = React.useState<boolean>(
    !!props.store.hasSeenInitialText
  );

  function _showForm(show: boolean) {
    setShowForm(show);
    props.updateStore({ hasSeenInitialText: show });
  }

  const { store, updateStore } = props;
  return (
    <div className={styles.background}>
      {showForm && (
        <span
          className={styles.verOtraVez}
          onClick={() => {
            _showForm(false);
          }}
        >
          <span className="fa fa-redo-alt"></span>
        </span>
      )}
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.registroEquipo}>
            <Typewriter
              key={showForm.toString()}
              className={classnames(styles.texto)}
              done={store.hasSeenInitialText}
              texts={[
                `Hola compañeros hackers,`,
                `Mi nombre en clave es Agente ${AGENT_GATO}, y pertenezco a una hermandad secreta de hackers éticos tan antigua como el mismo internet…`,
                `Llevamos tiempo detrás de los 6 grandes banqueros que manejan el sistema financiero mundial y por fin hemos conseguido entrar en sus servidores. Por eso hemos puesto en marcha la operación "Robin Hood"… ¡para robarles todo el dinero y acabar con los abusos de las altas esferas del poder!`,
                `Para completar esta misión con éxito, necesitaréis estar perfectamente coordinados, así que llama a tus amigos para poder estar comunicados. Además, necesitaréis conectaros cada uno en un ordenador distinto ya que está misión no puede ser completada en el móvil.`,
                `Cuando estéis listos, uno de vosotros deberá crear un equipo. El resto, buscad el equipo usando el código que os dará vuestro capitán.`,
              ]}
              onAnimationEnd={() => _showForm(true)}
            />
          </div>
          <RegistroEquipoForm
            className={showForm ? styles.showForm : styles.hideForm}
            done={store.hasSeenInitialText}
            updateStore={updateStore}
          />
        </div>
      </div>
    </div>
  );
}
